export default __webpack_public_path__ + "603aa4f72b313c4f067578227764a9df.png";